// extracted by mini-css-extract-plugin
module.exports = {"storageClassName":"CreatePVAndPVC_storageClassName-22oGI","icon":"CreatePVAndPVC_icon-3GgFg"};